export default "__VITE_PUBLIC_ASSET__7dd50349__"